import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Error404 from "./components/Common/Error404";
import Error500 from "./components/Common/Error500";
import Layout from "./components/layout";
import Home from "./pages/homePage/home/Home";
import PrivacyPolicy from "./pages/homePage/privacy-policy/PrivacyPolicy";
import TermsCondition from "./pages/homePage/terms-&-condition/TermsCondition";
import Blog from "./pages/homePage/Blog/Blog";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import AuthProtect from "./protect/AuthProtect";

import Domain from "./pages/dashboardPage/domain/Domain";
import DefaultLayout from "./components/dashboardLyout/DefaultLayout";
import InvoiceDetail from "./pages/dashboardPage/invoice-detail/InvoiceDetail";
import PaymentMethod from "./pages/dashboardPage/payment-method/PaymentMethod";
import Support from "./pages/dashboardPage/support/Support";
import Profile from "./pages/dashboardPage/profile/Profile";
import Dashboard from "./pages/dashboardPage/dashboard/Dashboard";
import "react-datepicker/dist/react-datepicker.css";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import GoogleAnalytics from "./utils/GoogleAnalytics";
import Reconcilations from "./pages/dashboardPage/reconcilations/Reconcilations";
import Adddomain from "./pages/dashboardPage/Add-domain/Adddomain";


const App = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when the location changes
  }, [location]);
  return (
    <>
      <GoogleAnalytics />
      <Routes>
        <Route element={<Error404 />} path={`/404`} />
        <Route element={<Error500 />} path={`/500`} />
        <Route path="*" element={<Navigate to="/404" />} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-password/:token" element={<ResetPassword />} />

        <Route element={<Layout />}>
          <Route path="/home" element={<Navigate to="/" />} />
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsCondition />} />
          <Route path="/blog" element={<Blog />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<AuthProtect />}>
          <Route element={<DefaultLayout />}>
            <Route path="/dashboard" element={<Navigate to="/user/dashboard" />} />
            <Route path="/user/domain/detail" element={<Domain />} />
            <Route path="/user/invoice/detail" element={<InvoiceDetail />} />
            <Route path="/user/payment/method" element={<PaymentMethod />} />
            <Route path="/user/support" element={<Support />} />
            <Route path="/user/profile" element={<Profile />} />
            <Route path="/user/dashboard" element={<Dashboard />} />
            <Route path="/user/reconcilations" element={<Reconcilations />} />
            <Route path="/user/add-domain" element={<Adddomain />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default App;
